export default "__VITE_ASSET__Czz7TWHX__"